import { moduleName } from '@edgvr-front/modules/domain';
import { dataModuleEntityId } from './dataModuleEntityId';
import { dataId } from './dataId';
import { dataModuleVORaw } from './dataModuleVORaw';
import { dataStartedAt } from './dataStartedAt';
import { dataVORaw } from './dataVORaw';
import { dataPersonEntityId } from './dataPersonEntityId';
import { dataPersonName } from './dataPersonName';
import { dataPersonVORaw } from './dataPersonVORaw';

export const dataPersonEntityRaw = {
  type: 'object',
  required: ['id', 'personName', 'dataId', 'data', 'dataPerson', 'startedAt'],
  properties: {
    id: dataPersonEntityId,
    personName: dataPersonName,
    dataId,
    data: dataVORaw,
    dataPerson: dataPersonVORaw,
    startedAt: dataStartedAt,
  },
  additionalProperties: false,
};
